import {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'

import {INTERVIEW_PHASE} from './hooks/useEnrichInterview'

/**
 * The answer card's footer during the Enrich interview (prototype
 * `foot-family`). Cancel stays up while the story is being read (a way out
 * of a slow request) and while asking, with `n of N answered` and Write my
 * story once anything is answered; nothing to press while the model is
 * writing; Keep my original / Use this version once the woven story is in,
 * with focus moved to Use this version as the card it replaces goes away.
 *
 * `cancelRef` is the Cancel button, which takes focus when the last question
 * is dismissed with nothing answered. `canWrite` is off while a write the
 * answers can't fix as they are (no room) is refused.
 */
const EnrichInterviewFooter = ({phase, answeredCount, total, canWrite, cancelRef, onCancel, onKeep, onWrite, onUse}) => {
  const result = phase === INTERVIEW_PHASE.RESULT
  const writing = phase === INTERVIEW_PHASE.WRITING
  const asking = phase === INTERVIEW_PHASE.ASK
  const useRef_ = useRef(null)

  useEffect(() => {
    if (result && useRef_.current) useRef_.current.focus()
  }, [result])

  return (
    <div className='ls-write-foot ls-refine-foot ls-fam-foot'>
      {asking && <span className='ls-fam-sum'>{answeredCount} of {total} answered</span>}
      {!writing && !result && <button className='ls-txt-btn' ref={cancelRef} type='button' onClick={onCancel}>Cancel</button>}
      {result && <button className='ls-txt-btn' type='button' onClick={onKeep}>Keep my original</button>}
      {
        result ?
          <button className='ls-fam-go' ref={useRef_} type='button' onClick={onUse}>Use this version</button> :
          asking && <button className='ls-fam-go' disabled={!canWrite} type='button' onClick={onWrite}>Write my story</button>
      }
    </div>
  )
}

EnrichInterviewFooter.propTypes = {
  answeredCount: PropTypes.number.isRequired,
  canWrite: PropTypes.bool.isRequired,
  cancelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),
  onCancel: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired,
  onUse: PropTypes.func.isRequired,
  onWrite: PropTypes.func.isRequired,
  phase: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired
}

export default EnrichInterviewFooter
